module.exports = __webpack_public_path__ + "img/zsd.79cb5e81.svg";